import React, { Component } from 'react';
import { flagAndCounts } from '../../../../api';
import Highcharts from 'highcharts/highstock';
import Highcharts3D from 'highcharts/highcharts-3d';
import {config2, config3} from "../data";
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';

class PieChart extends Component{
  constructor() {
    super();
    this.state = {
      block: true
    };
  }
  componentDidMount() {
    this.mounted = true;
    flagAndCounts({}, {headers: {'tenantname': this.props.name}})
      .then(res=>{
        let data = res.data || {};
        if (this.mounted) {
          this.setState({block: false}, ()=>{
            config2.series[0].data[0][1] = data.subscribedCount;
            config2.series[0].data[1][1] = data.unsubscribedCount;

            config3.series[0].data[1][1] = data.disableCount;
            config3.series[0].data[0][1] = data.enableCount;

            Highcharts3D(Highcharts);
            Highcharts.chart('subscribePieChart', config2);
            Highcharts.chart('actionPieChart', config3);
          });
        }
      })
      .catch(err=>console.log(err));
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    let  { block } = this.state;
    return (
      <div className="tab-pane fade" id="s2">
        <BlockUi tag="div"
                 loader={<Loader active type="ball-grid-pulse" color="#808080"/>}
                 blocking={block}>
          <div className="row">
            <div className="col-sm-6">
              <div id="subscribePieChart"
                   style={{height: 400}}
                   className="chart has-legend" />
            </div>
            <div className="col-sm-6">
              <div id="actionPieChart"
                   style={{height: 400}}
                   className="chart has-legend" />
            </div>
          </div>
        </BlockUi>
      </div>
    );
  }
}

export default PieChart;


// WEBPACK FOOTER //
// ./src/container/dashboard/model/charts/pieChart.js